import { createSlice } from '@reduxjs/toolkit'

// Setup the initial state

const initialState = {
  isWithinWorkHours: true,
};

export const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {

    // Set true/false if the current time is within work hours/days

    setIsWithinWorkHours: (state, action) => {
      state.isWithinWorkHours = action.payload;
    },

  },
})

export const {
  setIsWithinWorkHours,
} = calendarSlice.actions

export default calendarSlice.reducer;